import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, timeout } from 'rxjs/operators';
import { environment } from '@/src/environments/environment';
import { parseProperties } from './parseProperties.utils';

const baseTranslationsUrl = '/assets/i18n/';
const translationSuffix = '.properties';
const remoteTimeoutMs = 3000;

export class StxTranslateLoader implements TranslateLoader {
  constructor(private httpClient: HttpClient, private staticFilesUrl: string | null = environment.staticFilesUrl) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    if (!this.staticFilesUrl) {
      return this.loadBundled(lang);
    }

    const remoteRoot = `${this.staticFilesUrl}/i18n`;
    return this.httpClient.get<{ version: string }>(`${remoteRoot}/manifest.json`).pipe(
      timeout(remoteTimeoutMs),
      switchMap(manifest =>
        this.httpClient
          .get(`${remoteRoot}/${encodeURIComponent(manifest.version)}/${lang}${translationSuffix}`, {
            responseType: 'text'
          })
          .pipe(timeout(remoteTimeoutMs), map(parseProperties))
      ),
      catchError(() => this.loadBundled(lang))
    );
  }

  private loadBundled(lang: string): Observable<TranslationObject> {
    return this.httpClient.get(`${baseTranslationsUrl}${lang}${translationSuffix}`, { responseType: 'text' }).pipe(map(parseProperties));
  }
}
